import { formatPhoneNumber } from 'shared-it-appmod-ui';
import { IPilotState, actionTypes } from 'src/ducks/pilot.duck';
import { IStatus } from 'src/libraries/thunk.library';
import { IPilot } from 'src/models/pilot.model';

export const getPilotStatus = (
  state: IPilotState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };

export const formatPilotData = (data: IPilot) => {
  if (data.phone) {
    return {
      ...data,
      phone: formatPhoneNumber(data.phone),
    };
  }

  return data;
};
